import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PageResponse } from '@core/shared/domain';

import type {
  ClinicCatalog,
  ClinicCatalogInfo,
  ClinicCatalogOpenTasks,
  OrganizationBasic,
  UpdateClinicCatalog,
} from './clinic-catalog';

@Injectable({ providedIn: 'root' })
export class ClinicCatalogService {
  private readonly baseApiPath = 'api/contentmanagement/cliniccatalogs';

  constructor(private readonly httpClient: HttpClient) {}

  getAll(params?: HttpParams): Observable<PageResponse<ClinicCatalog>> {
    return this.httpClient.get<PageResponse<ClinicCatalog>>(`${this.baseApiPath}`, { params });
  }

  updateClinicCatalog(catalogId: string, dto: UpdateClinicCatalog): Observable<ClinicCatalog> {
    return this.httpClient.put<ClinicCatalog>(`${this.baseApiPath}/${catalogId}`, dto);
  }

  getClinicCatalogDetail(katalogId: string): Observable<ClinicCatalog> {
    return this.httpClient.get<ClinicCatalog>(`${this.baseApiPath}/${katalogId}`);
  }

  getAvailableOrganisations(params?: HttpParams): Observable<PageResponse<OrganizationBasic>> {
    return this.httpClient.get<PageResponse<OrganizationBasic>>(`${this.baseApiPath}/organizations`, { params });
  }

  getOpenTasks(id: string): Observable<ClinicCatalogOpenTasks> {
    return this.httpClient.get<ClinicCatalogOpenTasks>(`${this.baseApiPath}/${id}/opentasks`);
  }

  getClinicCatalogInfo(): Observable<ClinicCatalogInfo | null> {
    return this.httpClient.get<ClinicCatalogInfo | null>('api/m/contentmanagement/cliniccatalogs/info');
  }
}
